
import './App.css';
import { ButtonK } from './Control';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js'
import { Carousel } from 'react-bootstrap';
import { Provider } from 'react-redux';
import store from './Redux/Store'
import HomePage from './Page/Header/HomePage';
import Layout from './Component/Layout/Layout';
import { Routes, Route, Navigate, Link } from "react-router-dom";
import Shop from './Component/Shop/Shop';
function App() {
  return (
    <>
      <Provider store={store}>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/*" element={<Navigate to='/' />} />
          </Routes>
        </Layout>
      </Provider>
    </>
  );
}

export default App;
